module.exports = __webpack_public_path__ + "static/media/Cyrkulacja2.57b8c7aa.svg";